import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { isSupabaseConfigured } from '@/config';
import { useAuth } from '@/lib/auth/AuthProvider';
import { buyPrizeTicket, getActivePrizeDraw } from '@/lib/data/provider';

const KEY = ['prize-draw'];

export function useActivePrizeDraw() {
  const { userId } = useAuth();
  return useQuery({
    queryKey: [...KEY, userId ?? 'anon'],
    queryFn: getActivePrizeDraw,
    enabled: isSupabaseConfigured,
  });
}

export function useBuyPrizeTicket() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (drawId: string) => buyPrizeTicket(drawId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: KEY });
      queryClient.invalidateQueries({ queryKey: ['wallet'] });
    },
  });
}
